
import { defineComponent } from "vue";
import MainMenu from "@/views/mainMenu/MainMenu.vue";
import { DxScrollView } from "devextreme-vue/scroll-view";
import pollingMixin from "@/mixins/PollingMixin";
import { scrollDisabled } from "@/store/uiState";

export default defineComponent({
  components: {
    MainMenu,
    DxScrollView,
  },
  mixins: [pollingMixin],
  props: {},
  methods: {
    onPollCallback(data: any) {
      this.serverTime = data;
    },
  },
  data() {
    return {
      serverTime: "",
    };
  },
  computed: {
    scrollDisabledValue() {
      return scrollDisabled.value;
    },
  },
  async created() {
    this.startPolling(
      `/ServerUtil/GetFormattedServerTime`,
      this.onPollCallback,
      60000
    );
  },
});
